import {
  LayoutDashboard, Plus, List, CheckSquare,
  BarChart3, Mail, Users, Layers, BookOpen,
  FileText, Shield, Building2, Key,
  ClipboardList, Settings, TrendingUp, Brain, Palette, FolderArchive,
  Truck, AlertTriangle, Building, Trash2, Database, Receipt, KeyRound, Inbox,
  ServerCog, Map as MapIcon, ShieldCheck, Send, Activity, UserPlus
} from 'lucide-react';

const getNavSections = (t) => [
  {
    id: 'overview',
    label: t('nav.overview'),
    icon: LayoutDashboard,
    collapsible: false,
    items: [
      { label: t('nav.dashboard'), icon: LayoutDashboard, path: '/home', menuKey: 'dashboard' },
    ],
  },
  {
    id: 'complaints',
    label: t('nav.complaintsManagement'),
    icon: ClipboardList,
    collapsible: true,
    defaultOpen: true,
    items: [
      { label: t('nav.newComplaint'), icon: Plus, path: '/complaints/new', permission: 'can_create_complaints', menuKey: 'neue_reklamation' },
      // SAP-Suche nur sichtbar, wenn REACT_APP_SAP_TENANT_ID gesetzt ist
      // (sonst landet User auf "SAP-Suche nicht aktiviert"-Hinweis).
      { label: t('nav.sapSearch', 'SAP-Suche'), icon: Database, path: '/sap/search', permission: 'can_use_sap_search', menuKey: 'sap_suche', requiresEnv: 'REACT_APP_SAP_TENANT_ID' },
      { label: t('nav.allComplaints'), icon: List, path: '/complaints-list', permission: 'can_view_complaints', menuKey: 'alle_reklamationen' },
      { label: t('nav.draftComplaints', 'SAP-Drafts'), icon: FileText, path: '/admin/intake-monitor', permission: 'can_view_complaints', menuKey: 'sap_drafts', badgeKey: 'draftsPending' },
      { label: t('nav.myTasks'), icon: CheckSquare, path: '/my-tasks', menuKey: 'meine_aufgaben' },
      { label: t('nav.actionsTracking'), icon: ClipboardList, path: '/actions-dashboard', permission: 'can_view_complaints', menuKey: 'maßnahmen_tracking' },
      { label: t('cost_postings.menuLabel', 'Kostenbuchungen'), icon: Receipt, path: '/cost-postings', permission: 'can_create_cost_posting', permissionAlt: 'can_approve_cost_posting', menuKey: 'cost_postings', badgeKey: 'costPostingsPending' },
      { label: t('nav.emailInbox'), icon: Mail, path: '/email-inbox', badgeKey: 'unreadEmails', permission: 'can_view_email_inbox', menuKey: 'email_eingang' },
    ],
  },
  {
    id: 'supplier',
    label: t('nav.supplierManagement', 'Lieferantenmanagement'),
    icon: Truck,
    collapsible: true,
    defaultOpen: false,
    items: [
      { label: t('nav.supplierClaims', 'Lieferantenreklamationen'), icon: AlertTriangle, path: '/supplier-claims', permission: 'can_view_supplier_claims', menuKey: 'lieferantenreklamationen', badgeKey: 'overdueQ2' },
      { label: t('nav.newSupplierClaim', 'Neue Q2-Meldung'), icon: Plus, path: '/supplier-claims/new', permission: 'can_create_supplier_claims', menuKey: 'neue_q2_meldung' },
      { label: t('nav.supplierMaster', 'Lieferanten-Stammdaten'), icon: Building, path: '/suppliers', permission: 'can_manage_suppliers', menuKey: 'lieferanten_stammdaten' },
    ],
  },
  {
    id: 'analytics',
    label: t('nav.analytics'),
    icon: TrendingUp,
    collapsible: true,
    defaultOpen: true,
    items: [
      { label: t('nav.analyticsDashboard'), icon: BarChart3, path: '/analytics', permission: 'can_view_analytics', menuKey: 'analytics_dashboard' },
      { label: 'Pareto-Analyse', icon: TrendingUp, path: '/analytics/pareto', permission: 'can_view_analytics', menuKey: 'pareto_analysis' },
    ],
  },
  {
    id: 'organisation',
    label: t('nav.organisation'),
    icon: Building2,
    collapsible: true,
    defaultOpen: false,
    items: [
      { label: t('nav.userManagement'), icon: Users, path: '/user-management', permission: 'can_manage_users', menuKey: 'benutzerverwaltung' },
      { label: t('nav.roleManagement'), icon: Key, path: '/role-management', permission: 'can_manage_users', menuKey: 'rollenverwaltung' },
      { label: t('nav.entraMappings', 'Entra-Gruppen-Mapping'), icon: Key, path: '/admin/entra-group-mappings', permission: 'can_manage_users', menuKey: 'entra_gruppen_mapping' },
      { label: t('nav.entraStatus', 'Entra ID — Status-Abfrage'), icon: Key, path: '/admin/entra-status', permission: 'can_manage_users', menuKey: 'entra_id_status' },
      { label: t('nav.identityInvitations', 'Identität — Einladungen & Freigaben'), icon: UserPlus, path: '/admin/identity/invitations', permission: 'can_manage_users', menuKey: 'identity_invitations' },
      { label: t('nav.plantOrganization'), icon: Building2, path: '/plant-matrix', permission: 'can_manage_users', menuKey: 'werksorganisation' },
      { label: t('nav.zqmOrganization'), icon: Layers, path: '/zqm-matrix', permission: 'can_manage_users', menuKey: 'zqm_organisation' },
      { label: t('nav.salesOrganization'), icon: Layers, path: '/catalog-management?tab=sales', permission: 'can_manage_users', menuKey: 'verkaufsorganisation' },
    ],
  },
  {
    id: 'sap_admin',
    label: t('nav.sapAdministration', 'SAP-Administration'),
    icon: ServerCog,
    collapsible: true,
    defaultOpen: false,
    items: [
      { label: t('nav.sapTenantAdmin', 'SAP-Tenant-Verwaltung'), icon: Database, path: '/sap-tenant-admin', permission: 'can_manage_sap_tenants', menuKey: 'sap_tenant_verwaltung' },
      { label: t('nav.sapMasterData', 'SAP-Stammdaten'), icon: FolderArchive, path: '/sap-master-data', permission: 'can_manage_users', menuKey: 'sap_stammdaten' },
      { label: t('nav.fieldMappings', 'Field-Mapping'), icon: MapIcon, path: '/admin/field-mappings', permission: 'can_manage_field_mappings', menuKey: 'field_mapping' },
      { label: t('nav.webhookStatus', 'Webhook-Status'), icon: Activity, path: '/admin/webhook-status', permission: 'can_view_webhook_events', menuKey: 'webhook_status' },
      { label: t('nav.sapOutbox', 'SAP-Outbox'), icon: Send, path: '/admin/sap-outbox', permission: 'can_view_outbox', menuKey: 'sap_outbox' },
      { label: t('nav.scimAudit', 'SCIM-Audit'), icon: ShieldCheck, path: '/admin/scim-audit', permission: 'can_view_scim_audit', menuKey: 'scim_audit' },
      { label: t('nav.scimTokens', 'SCIM-Tokens'), icon: KeyRound, path: '/admin/scim-tokens', permission: 'can_manage_scim_tokens', menuKey: 'scim_tokens' },
      { label: t('nav.dlqInbox', 'DLQ-Inbox'), icon: Inbox, path: '/admin/dlq-inbox', permission: 'can_replay_dlq', menuKey: 'dlq_inbox' },
      { label: t('nav.systemStatus', 'System-Status'), icon: Activity, path: '/admin/system-status', permission: 'can_view_secrets_status', menuKey: 'system_status' },
    ],
  },
  {
    id: 'kataloge',
    label: t('nav.catalogs'),
    icon: BookOpen,
    collapsible: true,
    defaultOpen: true,
    items: [
      { label: t('nav.catalogManagement'), icon: BookOpen, path: '/catalog-management', permission: 'can_view_complaints', menuKey: 'katalogverwaltung' },
    ],
  },
  {
    id: 'system',
    label: t('nav.system'),
    icon: Settings,
    collapsible: true,
    defaultOpen: false,
    items: [
      { label: t('nav.emailLog'), icon: FileText, path: '/email-log', permission: 'can_manage_users', menuKey: 'email_log' },
      { label: t('nav.intakeLedger', 'Eingangsüberwachung & SAP-Drafts'), icon: Inbox, path: '/admin/intake-monitor?tab=ledger', permission: 'can_manage_users', menuKey: 'intake_ledger' },
      { label: t('nav.auditLog'), icon: Shield, path: '/audit-log', permission: 'can_manage_users', menuKey: 'audit_log' },
      { label: t('nav.qualityGate'), icon: Settings, path: '/quality-gate-settings', permission: 'can_manage_users', menuKey: 'ki_quality_gate' },
      { label: t('nav.aiConfig'), icon: Brain, path: '/ai-configuration', permission: 'can_manage_users', menuKey: 'ki_konfiguration' },
      { label: t('nav.appearance'), icon: Palette, path: '/theme-settings', menuKey: 'erscheinungsbild' },
      { label: t('nav.handoverDocs', 'Dokumentation'), icon: FolderArchive, path: '/handover-docs', permission: 'can_manage_users', menuKey: 'dokumentation' },
      { label: t('nav.systemReset', 'System-Reset'), icon: Trash2, path: '/system-reset', permission: 'can_manage_users', menuKey: 'system_reset' },
    ],
  },
];

export default getNavSections;
